<div class="mb-6">
  <div class="flex items-center gap-3 mb-4">
    <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-100 dark:bg-brand-500/10">
      <svg class="h-6 w-6 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
      </svg>
    </div>
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Historial de llamadas</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">Llamadas registradas vía Twilio para este business</p>
    </div>
  </div>
  <div class="inline-flex items-center rounded-full bg-brand-50 dark:bg-brand-500/10 px-3 py-1 text-sm font-medium text-brand-700 dark:text-brand-400 border border-brand-200 dark:border-brand-500/20">
    <svg class="mr-1.5 h-4 w-4 text-brand-600 dark:text-brand-400" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
    </svg>
    {{ activeCalls }} en curso · {{ totalCalls }} totales
  </div>
</div>

<div class="rounded-xl border border-gray-200 bg-white shadow-theme-sm dark:border-gray-700 dark:bg-gray-900">
  <div class="border-b border-gray-100 dark:border-gray-700 px-5 py-4">
    <div class="flex flex-wrap items-center gap-3">
      <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-600 overflow-hidden">
        <button
          (click)="setFilter('all')"
          class="px-4 py-2 text-sm font-medium transition-colors"
          [class]="filterDirection === 'all' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'">
          Todas
        </button>
        <button
          (click)="setFilter('INBOUND')"
          class="px-4 py-2 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-600"
          [class]="filterDirection === 'INBOUND' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'">
          Entrantes
        </button>
        <button
          (click)="setFilter('OUTBOUND')"
          class="px-4 py-2 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-600"
          [class]="filterDirection === 'OUTBOUND' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'">
          Salientes
        </button>
        <button
          (click)="setFilter('MISSED')"
          class="px-4 py-2 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-600"
          [class]="filterDirection === 'MISSED' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'">
          Perdidas
        </button>
      </div>

      <div class="flex items-center gap-2 ml-auto">
        <div class="relative">
          <input
            type="text"
            [value]="searchQuery"
            (input)="onSearchChange($event)"
            placeholder="Buscar por número o SID..."
            class="h-10 w-72 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 pl-10 pr-4 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-500/20 transition-all">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>

        <button
          (click)="toggleFilters()"
          class="flex items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-600 px-4 py-2 text-sm font-medium transition-colors"
          [class.bg-brand-500]="showFilters"
          [class.text-white]="showFilters"
          [class.border-brand-500]="showFilters"
          [class.bg-white]="!showFilters"
          [class.text-gray-600]="!showFilters"
          [class.dark:bg-gray-800]="!showFilters"
          [class.dark:text-gray-300]="!showFilters">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
          </svg>
          Filtros
        </button>
      </div>
    </div>
  </div>

  @if (showFilters) {
    <div class="border-b border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-5 py-4">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">Estado</label>
          <select
            [(ngModel)]="filterStatus"
            (ngModelChange)="aplicarFiltros()"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 transition-all">
            <option value="">Todos</option>
            @for (s of statusOptions; track s.value) {
              <option [value]="s.value">{{ s.label }}</option>
            }
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">Duración mínima (s)</label>
          <input
            type="number"
            [(ngModel)]="filtroDuracionMin"
            (ngModelChange)="aplicarFiltros()"
            placeholder="ej. 60"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 transition-all">
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">Duración máxima (s)</label>
          <input
            type="number"
            [(ngModel)]="filtroDuracionMax"
            (ngModelChange)="aplicarFiltros()"
            placeholder="ej. 600"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 transition-all">
        </div>
        <div class="flex items-end">
          <button
            (click)="limpiarFiltros()"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            Limpiar filtros
          </button>
        </div>
      </div>
      <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
        Los filtros aplican sobre la página actual ({{ filteredCount }} resultados visibles). La búsqueda server-side queda pendiente.
      </p>
    </div>
  }

  @if (error) {
    <div class="px-5 py-3 text-sm text-error-600 dark:text-error-400 bg-error-50 dark:bg-error-500/10 border-b border-error-200 dark:border-error-500/20">
      {{ error }}
    </div>
  }

  @if (loading) {
    <div class="flex justify-center py-10">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    </div>
  } @else {
    <div class="overflow-x-auto custom-scrollbar">
      <table class="w-full">
        <thead>
          <tr class="border-b border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Dirección</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Desde</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Hacia</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Contacto</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Fecha</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Duración</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Agente</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Estado</th>
            <th class="px-5 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Recording</th>
            <th class="px-5 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50 dark:divide-gray-800">
          @for (call of filtered; track call.id) {
            <tr class="hover:bg-gray-50/60 dark:hover:bg-gray-800/40 transition-colors">
              <td class="px-5 py-4">
                @if (isMissed(call)) {
                  <span class="inline-flex items-center justify-center rounded-lg bg-red-50 dark:bg-red-500/10 p-2">
                    <svg class="h-4 w-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </span>
                } @else if (call.direction === 'INBOUND') {
                  <span class="inline-flex items-center justify-center rounded-lg bg-teal-50 dark:bg-teal-500/10 p-2">
                    <svg class="h-4 w-4 text-teal-600 rotate-[135deg]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                    </svg>
                  </span>
                } @else {
                  <span class="inline-flex items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-500/10 p-2">
                    <svg class="h-4 w-4 text-blue-600 rotate-[-45deg]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                    </svg>
                  </span>
                }
              </td>
              <td class="px-5 py-4 text-sm font-mono text-gray-700 dark:text-gray-300">{{ call.fromNumber || '—' }}</td>
              <td class="px-5 py-4 text-sm font-mono text-gray-700 dark:text-gray-300">{{ call.toNumber || '—' }}</td>
              <td class="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                @if (call.contactId) {
                  <span [title]="contactTitle(call.contactId)">{{ contactLabel(call) }}</span>
                } @else {
                  <span class="italic text-gray-400">—</span>
                }
              </td>
              <td class="px-5 py-4">
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDateTime(call.createdAt).date }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDateTime(call.createdAt).time }}</p>
              </td>
              <td class="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">{{ formatDuration(call.durationSeconds) }}</td>
              <td class="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                @if (call.agentId) {
                  <span [title]="agentTitle(call.agentId)">{{ agentLabel(call) }}</span>
                } @else {
                  <span class="italic text-gray-400">—</span>
                }
              </td>
              <td class="px-5 py-4">
                @if (call.status === 'COMPLETED') {
                  <span class="inline-flex items-center rounded-full bg-success-50 px-2.5 py-0.5 text-xs font-medium text-success-700 border border-success-100 dark:bg-success-500/10 dark:text-success-400 dark:border-success-500/20">Completada</span>
                } @else if (call.status === 'IN_PROGRESS') {
                  <span class="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700 border border-blue-100 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/20">En curso</span>
                } @else if (call.status === 'INITIATED') {
                  <span class="inline-flex items-center rounded-full bg-warning-50 px-2.5 py-0.5 text-xs font-medium text-warning-700 border border-warning-100 dark:bg-warning-500/10 dark:text-warning-400 dark:border-warning-500/20">Iniciada</span>
                } @else if (call.status === 'NO_ANSWER' || call.status === 'BUSY' || call.status === 'FAILED') {
                  <span class="inline-flex items-center rounded-full bg-error-50 px-2.5 py-0.5 text-xs font-medium text-error-700 border border-error-100 dark:bg-error-500/10 dark:text-error-400 dark:border-error-500/20">{{ statusLabel(call.status) }}</span>
                } @else {
                  <span class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 border border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600">{{ statusLabel(call.status) }}</span>
                }
              </td>
              <td class="px-5 py-4">
                @if (call.recordingUrl) {
                  <a [href]="call.recordingUrl" target="_blank" rel="noopener" class="text-xs text-brand-600 hover:underline dark:text-brand-400">Audio</a>
                } @else {
                  <span class="text-xs text-gray-400">—</span>
                }
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center justify-center gap-1">
                  <button
                    (click)="viewCallDetail(call)"
                    class="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors dark:hover:bg-gray-700"
                    title="Ver detalle">
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }

          @if (filtered.length === 0) {
            <tr>
              <td colspan="10" class="px-5 py-12 text-center">
                <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                  <svg class="h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                  <span>No hay llamadas que coincidan con los filtros.</span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 0) {
      <div class="flex items-center justify-between border-t border-gray-100 dark:border-gray-700 px-5 py-4">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Mostrando página <span class="font-medium text-gray-900 dark:text-white">{{ page + 1 }}</span> de <span class="font-medium text-gray-900 dark:text-white">{{ totalPages }}</span> · {{ totalElements }} llamadas totales
        </p>
        <div class="flex items-center gap-2">
          <button
            (click)="prevPage()"
            [disabled]="!hasPrevious"
            class="rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-1.5 text-sm font-medium text-gray-600 dark:text-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            Anterior
          </button>
          <button
            (click)="nextPage()"
            [disabled]="!hasNext"
            class="rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-1.5 text-sm font-medium text-gray-600 dark:text-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    }
  }
</div>

<!-- Modal de detalle de llamada con audio player -->
<app-modal [isOpen]="showDetailModal" (close)="closeDetailModal()" className="max-w-2xl mx-4 sm:mx-6">
  @if (selectedCall) {
  <div class="p-6">
    <div class="mb-5 flex items-center gap-3">
      @if (isMissed(selectedCall)) {
      <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-error-50 dark:bg-error-500/10">
        <svg class="h-6 w-6 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </div>
      } @else if (selectedCall.direction === 'INBOUND') {
      <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-teal-50 dark:bg-teal-500/10">
        <svg class="h-6 w-6 text-teal-600 rotate-[135deg]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
      } @else {
      <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 dark:bg-blue-500/10">
        <svg class="h-6 w-6 text-blue-600 rotate-[-45deg]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
        </svg>
      </div>
      }
      <div>
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Detalle de llamada</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ statusLabel(selectedCall.status) }} · {{ directionLabel(selectedCall.direction) }}</p>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-4 mb-5">
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Desde</p>
        <p class="text-sm font-mono text-gray-900 dark:text-white">{{ selectedCall.fromNumber || '—' }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Hacia</p>
        <p class="text-sm font-mono text-gray-900 dark:text-white">{{ selectedCall.toNumber || '—' }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Fecha</p>
        <p class="text-sm text-gray-900 dark:text-white">{{ formatDateTime(selectedCall.createdAt).date }} · {{ formatDateTime(selectedCall.createdAt).time }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Duración</p>
        <p class="text-sm text-gray-900 dark:text-white">{{ formatDuration(selectedCall.durationSeconds) }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Dirección</p>
        <p class="text-sm text-gray-900 dark:text-white">{{ directionLabel(selectedCall.direction) }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Agente</p>
        <p class="text-sm text-gray-900 dark:text-white" [title]="agentTitle(selectedCall.agentId)">{{ agentLabel(selectedCall) }}</p>
      </div>
      @if (selectedCall.contactId) {
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Contacto</p>
        <p class="text-sm text-gray-900 dark:text-white" [title]="contactTitle(selectedCall.contactId)">{{ contactLabel(selectedCall) }}</p>
      </div>
      }
      @if (selectedCall.callSid) {
      <div class="col-span-2">
        <p class="text-xs text-gray-500 dark:text-gray-400">Twilio Call SID</p>
        <p class="text-xs font-mono text-gray-600 dark:text-gray-400 break-all">{{ selectedCall.callSid }}</p>
      </div>
      }
    </div>

    <div class="border-t border-gray-200 dark:border-gray-700 pt-4">
      <p class="text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-2">Grabación</p>
      @if (selectedCall.recordingUrl) {
      <audio controls preload="none" class="w-full" [src]="selectedCall.recordingUrl"></audio>
      <a [href]="selectedCall.recordingUrl" target="_blank" rel="noopener" class="mt-2 inline-flex items-center gap-1 text-xs text-brand-600 hover:underline dark:text-brand-400">
        <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
        </svg>
        Descargar / abrir en nueva pestaña
      </a>
      } @else {
      <p class="text-sm italic text-gray-400 dark:text-gray-500">Esta llamada no tiene grabación.</p>
      }
    </div>

    <div class="mt-6 flex justify-end">
      <button
        type="button"
        (click)="closeDetailModal()"
        class="rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
  }
</app-modal>
